/*
* Created on Mar 11, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useRef, useState} from 'react';
import ModalComponent from "../../common/ModalComonent/ModalComponent";
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";
import {get_primary_email} from "../../../service/common"


const OrganizationDeleteModalComponent = ({openModal, closeModal, organization}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const [stage, setStage] = useState('stage_1');
    const [error, setError] = useState(false);
    const [input, setInput] = useState({name: {value: '', error: '', required: true}, reason: {value: '', code: '', error: '', required: true}}); const textArea = useRef();
    const modal = useRef();
    const currentUser = JSON.parse(window.localStorage.getItem('currentUser'));
    const deleteReason = [
        t('@I am not using this feature anymore.@'),
        t('@I don\'t understand how to use the organization feature.@'),
        t('@I have a duplicate organization.@'),
        t('@I don\'t find organizatiton feature is useful.@'),
        t('@I am worried about the security of my organization data.@'),
        t('@This is temporary, I\'ll be back.@'),
    ]

    const verifyOrgName = (typed_name) => {
        let err = false;
        if (typed_name !== organization.name) {
            err = true;
            setError(true);
        }
        else {
            err = false;
            setError(false);
        }
        setInput(prevInput=>{
            return {...prevInput, name: {...prevInput.name, value: typed_name, error: err ? 'Name not matched' : ''}}
        })
    }

    const onSelectReason = (value, message) => {
        if (value < 0 && input?.reason?.code !== 6) return;
        let reason = message;
        if (value === 6 || (value < 0 && input?.reason?.code === 6)) {
            reason = textArea.current.value;
        }

        setInput(prevInput=>{
            console.log(prevInput);
            const data = {...prevInput,
                reason: {
                    ...prevInput.reason,
                    value: reason,
                    code: value < 0 ? prevInput?.reason?.code : value,
                    error: (reason === '' && value === 6) || ((value >=0 && value <=5) && !message)  ? 'Need a Reason' : ''
                }
            }
            console.log(data);
            return data;
        })

    }

    const onSubmit = async () => {
        if (stage === 'stage_1') {
            const data = {
                name: input.name.value,
                reason_text: input.reason.value,
                reason_code: input.reason.code
            }
            try {
                await OrganizationAPI.post(`organization/${organization.organization_id}/request_delete`, null, data);
                setStage('stage_2');
                modal.current.alert(false, 'success', 0, '', 0.1);
                modal.current.setShowSubmit(false);
                modal.current.setCancelText('@I got it!@');
            } catch (e) {
                throw e;
            }
        }
        else if (stage === 'stage_2') {
            closeModal()
        }
    }

    return (
        <ModalComponent isOpen={openModal} onClose={closeModal} onSubmit={onSubmit} title={t('@Permanently Delete Organization@')} modalSize={'none'} input={input} okText={t('@Verify via Email@')} ref={modal}>
            <div className="dialog-content">
                {/* Section 1 */}
                <div className={`${stage==='stage_1' ? '' : 'hide'}`}>
                    <div className="text-wrap !mb-24">
                        <span className="text-alert">
                            <b>{t('@Warning:@')}
                            </b> {t('@Deleting an organization permanently deletes all organization data. Are you sure you want to delete the organization?@')}
                        </span>
                    </div>
                    <div className="text-wrap !mb-12 required">{t('@Enter this organization\'s name to confirm@')}</div>
                    <div className="text-input-wrap !mb-24">
                        <input type="text" className={error ? 'invalid': ''} value={input.name.value} onChange={e=>verifyOrgName(e.target.value)}/>
                        {error && <div className="text-error">{t('@Incorrect organization name@')}</div>}
                    </div>
                    <div className="text-wrap !mb-12 required">{t('@Reason for leaving@')}</div>
                    <div className="sub-content">
                        {deleteReason.map((r,index)=>(
                            <div className="text-wrap" key={index}>
                                <div className="comp-radio-group">
                                    <div className="comp-radio">
                                        <input type="radio" id={`rb-${index}`} name="leaving-reason" value={index} onClick={()=>onSelectReason(index, r)}/>
                                        <label htmlFor={`rb-${index}`} className="comp-label" />
                                    </div>
                                    <div className="val-field">{r}</div>
                                </div>
                            </div>
                        ))}
                        <div className="text-wrap">
                            <div className="comp-radio-group">
                                <div className="comp-radio">
                                    <input type="radio" id="rb-7" name="leaving-reason" value={6} onClick={()=>onSelectReason(6, 'other')}/>
                                    <label htmlFor="rb-7" className="comp-label" />
                                </div>
                                <div className="val-field">{t('@Other@')}</div>
                            </div>
                        </div>
                        <div className="text-wrap !mb-0"><textarea ref={textArea} onChange={()=>onSelectReason(-1, 'other')}/></div>
                    </div>
                </div>
                {/* section 2*/}
                <div className={`${stage==='stage_2' ? '' : 'hide'}`}>
                    <div className="dialog-content">
                        <div className="text-wrap">{t('@An email requesting confirmation has been sent to@')} <span
                            className="single-hilight inline !pl-4 !pr-4">{get_primary_email(currentUser)}</span></div>
                        <div className="text-wrap">{t('@Please check your email to confirm the deletion of organization by clicking the provided link.@')}
                        </div>
                    </div>
                </div>
            </div>
        </ModalComponent>
    );
};

export default OrganizationDeleteModalComponent;